<template>
    <div :class="theme.layout">
        <navigation />
        <div :class="theme.content">
            <app-bar />
            
            <bread-crumbs />
            <navigation-tabs />          
                

                <div v-if="profile.notifications">
                    <div v-for="notification, index in profile.notifications" :key="index" v-padding="5" :class="theme.infoBlock">
                        <div :class="`${theme.blockIcon} ${theme.blockIcon__info}`" v-margin.right="4">
                            <v-font-icon white regular>
                            info
                            </v-font-icon>
                        </div>
                        <v-text  secondary type="subheadling">
                            {{notification}}
                        </v-text>
                    </div>
                </div>
                
                <div v-if="tariff && (tariff.daysLeft <= 10 && !tariff.hasInactivePackages)" v-padding="5" :class="theme.infoBlock" >
                    <div :class="`${theme.blockIcon} ${theme.blockIcon__info}`" v-margin.right="4">
                        <v-font-icon white regular>
                            notifications_none
                        </v-font-icon>
                    </div>

                    
                
                    <v-text secondary type="subheadling">                        
                        <span secondary v-if="profile.contactFIO">
                            {{profile.contactFIO}}, напоминаем об истечении срока действия тарифа.<br />
                        </span>
                        <span secondary v-else>
                            Напоминаем об истечении срока действия тарифа.<br />
                        </span>
                        Тариф действует до {{new Date(tariff.endDate).toLocaleDateString("ru-RU")}}.
                    </v-text>
                </div>
            

            <div :class="theme.content">
                <div :class="theme.container">
                    <slot></slot>
                </div>
            </div>
            <app-footer />
        </div>
    </div>
</template>
<script>
import { AppBar } from '../AppBar';
import { AppFooter } from '../AppFooter';
import { Navigation } from '../Navigation';
import { NavigationTabs } from '../NavigationTabs';
import { BreadCrumbs } from '../BreadCrumbs';
import theme from './theme.scss';
import { mapState } from 'vuex';

export default {
    name: 'home-layout',
    props: {
        theme: {
            type: Object,
            default() {
                return theme;
            }
        }
    },
    components: {
        Navigation,
        NavigationTabs,
        AppBar,
        AppFooter,
        BreadCrumbs,
    },
    computed: {
        ...mapState('profileTariff', ['tariff']),
        ...mapState('profile', ['profile'])
    }
}
</script>



// WEBPACK FOOTER //
// HomeLayout.vue?7bdd417a